//====================================================
//  Function: Code select
//====================================================
// const myTimeoutCode;

function componentCodeSelect() {
  if ($('.js-select-result').length) {
    $('.js-select-option').change(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
			$('div').removeClass('is-clicked');
			$('.code-box__item').removeClass('is-clicked');
			// clearTimeout(myTimeoutCode);
			addToResultCode(checkbox)
    })

    $('.js-select-input').keyup(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
			$('div').removeClass('is-clicked');
			$('.code-box__item').removeClass('is-clicked');
			// clearTimeout(myTimeoutCode);
			addToResultCode(checkbox)
    })
  }
}

function addToResultCode(checkbox) {
  var arrayResultSide = []
	var arrayResult = []

	if (checkbox.closest('.stats__item').length > 0){
		checkbox.closest('.js-stats').addClass('is-clicked');
	} else {
		checkbox.addClass('is-clicked');
	}

  $('.js-select-item').each(function () {
    var item = $(this)

    if (item.data('comment') !== undefined) {
      if (item.data('comment').length && $('html.is-hu').length == 0) {
        arrayResult.push(
          "<div class='code__comment'>// " + item.data('comment') + '</div>',
        )
      }
    }

    item.find('.js-stats').each(function () {
      var element = $(this)
      var checkedCheckbox = element.find('.js-select-option:checked')
			var checkboxValue = checkedCheckbox.val()
			var clickedClass = "";
      var checkboxCode = element.data('code')
      var checkboxQuotes = element.data('quotes')

      if (checkboxQuotes == true) {
				checkboxValue = '"' + checkboxValue + '"'
      }

			if (element.hasClass('is-clicked')) {
				clickedClass = "is-clicked"
			}

      // if (checkboxValue === 'false' || checkboxValue === '"left"') {
      //   return false
      // }

      var templateBoxItem = `
			<div class="code-box__item ${clickedClass}">
			<strong>var <span class="js-result-type">${checkboxCode}</span> = <span class="js-result-value txt-green">${checkboxValue};</span></strong></div>
			`
      arrayResult.push(templateBoxItem)
      arrayResultSide.push(templateBoxItem)
    })

    item.find('.js-select-input').each(function () {
			var input = $(this)
			var clickedClass = "";
      var inputValue = input.val()
			var inputCode = input.data('code')

			if (input.hasClass('is-clicked')) {
				clickedClass = "is-clicked"
			}

      var templateBoxItem = `
					<div class="code-box__item ${clickedClass}">
					<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">"${inputValue}";</span></strong></div>
			`
      arrayResult.push(templateBoxItem)
      arrayResultSide.push(templateBoxItem)
    })

    if (item.hasClass('line-break')) {
      arrayResult.push('<br>')
      // arrayResultSide.push('<br>')
    }
	})

	// myTimeoutCode = setTimeout(() => {
	// 	checkbox.closest('.js-select-item').removeClass('is-clicked');
	// }, 3000);

  $('.js-code-result').empty()
  $('.js-code-result--side').empty()
  // $('.js-code-result .code__comment').remove()
  // $('.js-code-result--side .code__comment').remove()
  // $('.js-code-result br').remove()
  // $('.js-code-result--side br').remove()
  $('.js-code-result').append(arrayResult)
  $('.js-code-result--side').append(arrayResultSide)
}
